export const authenticationConstants = {
  AUTHENTICATION_REQUEST: 'AUTHENTICATION_REQUEST',
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  AUTHENTICATION_FAILURE: 'AUTHENTICATION_FAILURE',
  RESSET_PASSWORD_SUCCES: 'RESSET_PASSWORD_SUCCES',
  SET_USER_NEW_PASS: 'SET_USER_NEW_PASS',
  VALIDATE_PIN: 'VALIDATE_PIN'
}
